import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute, useRouter } from 'vue-router';
  import { onMounted } from 'vue';
  import { authStore } from '@/stores';
  import { useToast } from 'bootstrap-vue-3';
  import { ColorVariants } from '@/constants';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { params: { token } } = useRoute();
  const router = useRouter();
  const toast = useToast();

  onMounted(async () => {
    if (!token) {
      router.replace({ name: 'login' });
      return;
    }
    try {
      // 先退出登录
      authStore.signOut();
      await authStore.loginSsoToken(String(token), { loading: { silent: true } });
    } catch (e: any) {
      toast.show({ body: e.message }, { variant: ColorVariants.danger });
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      router.replace({ name: 'home' });
    }
  });

  const RenderNode = () => null;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RenderNode))
}
}

})